// Invite links — the label rule, shared by Create and Rename (VRG-794). Pure, so the platform
// guard can import it. The API is the control (tracked-links.service.ts `clean(label, 120)`
// + the DTOs' @MaxLength(120)); this pins that the form never offers a value it will bounce.

/** The API's limit (RelabelTrackedLinkDto / CreateTrackedLinkDto). */
export const TRACKED_LINK_LABEL_MAX = 120

/** The same check the API makes: trimmed, not blank, at most 120 characters. */
export const labelError = (raw: string): string | null => {
  const v = raw.trim()
  if (!v) return 'Give the link a label'
  if (v.length > TRACKED_LINK_LABEL_MAX) return `Keep it to ${TRACKED_LINK_LABEL_MAX} characters`
  return null
}
